import * as React from "react";
import SocialView from "../presentation/social-responsibility";
export default class SocialResponsibility extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(SocialView, null));
    }
}
;
//# sourceMappingURL=social-responsibility.js.map